import clsx from 'clsx'
import { INavBarProps } from './types'
import styles from './styles.module.scss'

const NavBar = ({ items, label = 'Navigation Bar', style, ...props }: INavBarProps) => {
  const currentPage = items.find((item) => item.isCurrent)?.id || items[0].id
  return (
    <nav
      className={clsx('mui-navigation-bar', styles.navigationBar)}
      data-testid="mui-navigation-bar"
      style={{ ...style }}
      {...props}
    >
      <ul aria-label={label} className={`${styles.navigationBarList}`} role="tablist">
        {items.map((tab) => (
          <li key={`${tab.id}-tab`}>
            {tab.asButton ? (
              <button
                aria-controls={`${tab.id}-tab`}
                className={clsx(styles.button, {
                  [styles.disabled]: tab.isDisabled,
                  [styles.currentPage]: tab.isCurrent,
                })}
                id={tab.id}
                role="tab"
                onClick={tab.onClick}
              >
                <span className={styles.label}>{tab.label}</span>
                {tab.hasBadge && <span aria-hidden={true} className={styles.badge}></span>}
              </button>
            ) : tab.isCurrent ? (
              <span
                aria-controls={`${tab.id}-tab`}
                aria-selected={`${tab.id === currentPage}`}
                aria-current={`${tab.id === currentPage && 'page'}`}
                className={clsx(styles.listItem, styles.currentPage, {
                  [styles.disabled]: tab.isDisabled,
                })}
                id={tab.id}
                role="tab"
              >
                <span className={styles.label}>{tab.label}</span>
                {tab.hasBadge && <span aria-hidden={true} className={styles.badge}></span>}
              </span>
            ) : (
              <a
                aria-controls={`${tab.id}-tab`}
                aria-selected={`${tab.id === currentPage}`}
                aria-current={`${tab.id === currentPage && 'page'}`}
                className={clsx({
                  [styles.disabled]: tab.isDisabled,
                })}
                id={tab.id}
                href={tab.href}
                role="tab"
              >
                <span className={styles.label}>{tab.label}</span>
                {tab.hasBadge && <span aria-hidden={true} className={styles.badge}></span>}
              </a>
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default NavBar
